<template>
  <div>
    <el-row>
      <div class="page-body">
        <div style="display: flex; justify-content: space-between">
          <div>
            <el-form
              :inline="true"
              class="demo-form-inline"
              label-position="right"
              label-width="100px"
              :model="searcheForm"
            >
              <el-form-item label="站点名称:">
                <el-input
                  placeholder="请输入昵称"
                  clearable
                  width="200px"
                  v-model="searcheForm.stationName"
                ></el-input>
              </el-form-item>
              <el-button icon="el-icon-search" type="primary" @click="search"
                >搜索</el-button
              >
            </el-form>
          </div>
          <div>
            <el-button type="primary" icon="el-icon-plus" @click="showAdd"
              >新增</el-button
            >
          </div>
        </div>
      </div>
    </el-row>
    <el-row>
      <el-col :span="6">
        <!-- tree -->
        <el-tree
          :data="treeData"
          show-checkbox
          node-key="treeId"
          default-expand-all
          :expand-on-click-node="false"
        >
          <span
            class="custom-tree-node"
            slot-scope="{ node, data }"
            style="width: 100%"
          >
            <el-row>
              <el-col :span="15"
                ><span @click="()=>nodeClick(data)">Level-{{node.level}} |{{ data.treeName }}</span></el-col
              >
              <el-col :span="9">
                <span>
                  <el-button
                    type="text"
                    size="mini"
                    @click="() => appendGateway(data)" v-if="node.level==1"
                  >
                    添加网关
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    @click="() => appendPlug(data)" v-if="node.level==2"
                  >
                    添加插座
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    @click="() => remove(node, data)"
                  >
                    Delete
                  </el-button>
                </span>
              </el-col>
            </el-row>
          </span>
        </el-tree>
        <!-- tree-->
      </el-col>
      <el-col :span="18">
        <!-- 表格 start -->
        <div style="margin-top: 30px">
          <el-table
            :data="stationList"
            stripe
            border
            v-loading="loading"
            element-loading-text="正在加载..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            style="width: 100%"
          >
            <el-table-column
              prop="stationName"
              label="站点名称"
              fixed
              align="center"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="code"
              label="站点编码"
              width="300"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stationLng"
              label="经度"
              width="300"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stationLat"
              label="纬度"
              width="300"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stationTel"
              label="联系电话"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="serviceTel"
              label="服务电话"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="stationStatus"
              label="站点状态"
              width="300"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="durationOption"
              label="计费时段"
              width="300"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="privacyId"
              label="计费方式"
              width="300"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="address"
              label="详细地址"
              width="300"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              width="500"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="updateTime"
              label="更新时间"
              width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              fixed="right"
              width="200"
              align="center"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button @click="showEditStationView(scope.row)"
                  >编辑</el-button
                >
                <el-button @click="deleteChargeStation(scope.row)" type="danger"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex; justify-content: flex-end">
            <el-pagination
              background
              @current-change="currentChange"
              @size-change="sizeChange"
              layout="sizes, prev, pager, next, jumper, ->, total, slot"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <!-- 表格 END -->
      </el-col>
    </el-row>

    <el-dialog :title="title" :visible.sync="dialogVisible" width="1200px">
      <div style="width: 800px">
        <el-form
          :model="form"
          :rules="formRules"
          ref="formRef"
          label-position="right"
          label-width="150px"
          size="600px"
        >
          <el-form-item label="物业名称:" prop="stationName">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.stationName"
              placeholder="请输入物业名车给"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址:" prop="address">
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.address"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="经度:"
            prop="form.stationLng"
            style="display: block"
          >
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.stationLng"
              placeholder="请输入经度"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="纬度:"
            prop="form.stationLat"
            style="display: block"
          >
            <el-input
              size="mini"
              style="width: 100%"
              prefix-icon="el-icon-edit"
              v-model="form.stationLat"
              placeholder="请输入纬度"
            ></el-input>
          </el-form-item>
          <el-form-item label="计费方式:" prop="feeType">
            <el-select v-model="form.feeType" placeholder="请选择" disabled>
              <el-option
                v-for="item in feeTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充电时段设置:" prop="durationOption">
            <el-input
              size="mini"
              style="width: 85%"
              prefix-icon="el-icon-edit"
              v-model="form.durationOption"
              placeholder="请输入充电时段，以逗号[,]分割"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <span>充电时段用于选择充电用户可选择充电时长，如[1,2,4,8]</span>
          </el-form-item>
          <el-form-item label="价格:" prop="price" style="width: 100%">
            <el-input
              size="mini"
              oninput="value=value.replace(/[^\d]/g,'')"
              style="width: 85%"
              prefix-icon="el-icon-edit"
              v-model="form.price"
              placeholder="请输入计费价格 分/小时"
            ></el-input>
            <span>&nbsp;&nbsp;分/小时</span>
          </el-form-item>
          <el-form-item
            label="折扣费率:"
            prop="discountRate"
            style="display: none"
          >
            <el-input-number
              v-model="form.discountRate"
              @change="handleChange"
              :min="10"
              :max="1000"
              label="描述文字"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="免费充电时长:" prop="maxFreeMinutes">
            <el-input-number
              style="width: 85%"
              v-model="form.maxFreeMinutes"
              @change="handleChangeFreeFee"
              :min="0"
              :max="600"
              label="免费充电时长"
            ></el-input-number>
            <span>&nbsp;&nbsp;分钟</span>
          </el-form-item>

          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="footer">
        <el-button type="primary" @click="doUpdate">保存设置</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import { apiListStations, apiUpdate, apiGet, apiDelete, apiTree } from "./ChargeStation";

export default {
  name: "ChargeStation",
  data() {
    return {
      title: "", //模态窗口 标题
      searcheForm: {}, //搜索
      treeData: [{treeId:0,treeName:'Root'}], //列表数据
      stationList:[],
      loading: false,
      dialogVisible: false, // 是否显示 模态窗口
      total: 0,
      page: 1,
      size: 10,
      form: {
        feeType: 1,
        discountRate: 100,
        maxFreeMinutes: 0,
      },
      feeTypeOptions: [
        { label: "按小时", value: 1 },
        { label: "按电量", value: 2 },
      ],
      durationOptions: [
        { label: "1小时", value: 1 },
        { label: "2小时", value: 2 },
        { label: "3小时", value: 3 },
        { label: "4小时", value: 4 },
        { label: "5小时", value: 5 },
        { label: "6小时", value: 6 },
        { label: "7小时", value: 7 },
        { label: "8小时", value: 8 },
      ],
      formRules: {
        name: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请输入模板编码", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 15 个字符",
            trigger: "blur",
          },
        ],
        durationOption: [
          { required: true, message: "请输入充电时长配置", trigger: "blur" },
        ],
        price: [
          { required: true, message: "请输入充个价格信息", trigger: "blur" },
          {
            min: 1,
            max: 4,
            message: "单位为分 如  10 分/小时",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "请输入详细地址信息", trigger: "blur" },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "blur",
          },
        ],
        remark: [{ required: false, message: "请填写备注", trigger: "blur" }],
        stationLng: [
          {
            required: true,
            message: "经度整数部分为0-180,小数部分为0到6位!",
            trigger: "blur",
          },
        ],
        stationLat: [
          {
            required: true,
            message: "纬度整数部分为0-90,小数部分为0到6位!",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.feeType = 1;
    this.list();
  },
  mounted() {},
  methods: {
    search() {
      this.list();
    },
    showAdd() {
      this.title = "添加站点";
      this.form = {};
      this.dialogVisible = true;
    },
    //编辑站点信息
    showEditStationView(data) {
      this.title = "编辑";
      this.form = data;
      this.dialogVisible = true;
    },
    deleteChargeStation(row) {},
    // 页大小
    sizeChange(currentSize) {
      this.size = currentSize;
      this.list();
    },
    // 选择页
    currentChange(currentPage) {
      this.page = currentPage;
      this.list("advanced");
    },
    handleChange(v) {
      this.$refs.form.discountRate = v;
    },
    checkLong(lng) {
      var longrg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
      if (!longrg.test(lng)) {
        Message.error({ message: "经度整数部分为0-180,小数部分为0到6位!" });
        return false;
      }
      return true;
    },
    checkLat(lat) {
      var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
      if (!latreg.test(lat)) {
        Message.error({ message: "纬度整数部分为0-90,小数部分为0到6位!" });
        return false;
      }
      return true;
    },
    handleChangeFreeFee(v) {
      this.$refs.form.maxFreeMinutes = v;
    },
    list() {
      apiListStations(this.searcheForm).then((resp) => {
        if (resp.status == 200) {
          const data = resp.data;
          this.stationList = data.list;
          this.total = data.total;
          this.page = data.pageNum;
          this.size = data.pageSize;
        }
      });

      apiTree().then((resp)=>{
        if (resp.status == 200) {
          const data = resp.data;
          this.treeData = data;
        }
      })
    },
    doUpdate() {
      let url = "/api/chargeStation/update";
      const valid = this.$refs["formRef"].validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.checkLong(this.form.stationLng)) {
          return;
        }
        if (!this.checkLat(this.form.stationLat)) {
          return;
        }
        // checkDurationOption();
        putRequest(url, this.form).then((resp) => {
          console.log(JSON.stringify(resp));
          if (resp.status == 200) {
          }
        });
      });
    },
    checkDurationOption() {
      let durationOption = this.form.durationOption;
      if (durationOption == null || durationOption.length == 0) {
        Message.error({ message: "请设置有效的充电时段!" });
      }
      let index = durationOption.indexOf(",");
      let regex = /^\d+$/;
      if (index == -1) {
        if (!regex.test(durationOption)) {
          Message.error({
            message: "请设置有效的充电时段,只能输入数字，多时段通过,分割!",
          });
          return false;
        }
      }
      let texts = durationOption.split(",");
      for (let i = 0; i < texts.length; i++) {
        if (!regex.test(texts[i])) {
          Message.error({
            message: "请设置有效的充电时段," + texts[i] + "不是有效的参数",
          });
          return false;
        }
      }
      return true;
    },
    loadNode(node, resolve) {
       if (node.level === 0) {
        }
        if (node.level > 1) return resolve([]);

        setTimeout(() => {
          const data = [{
            stationName: 'leaf',
            leaf: true
          }, {
            stationName: 'zone'
          }];

          resolve(data);
        }, 500);
    },
    nodeClick(data){
        //data.children.push({treeId:new Date().getTime(),treeName:'插座网关'});
        console.log('You CLicked = '+JSON.stringify(data));
    }
  },
};
</script>

<style>
.page-body {
  margin-top: 30px;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.el-input--mini .el-input__inner {
  height: 48px;
  line-height: 48px;
}
.footer {
  padding-left: 500px;
}
</style>